module.exports = __webpack_public_path__ + "img/no.4bfa56ed.svg";